<ng-container *ngIf="!editingTemplate">
    <div class="p-grid p-fluid">
        <div class="p-sm-6 p-col-12">
            <label class="w-full">
                Default Template
                <template-selector [(ngModel)]="defaultTemplateItem.value" [log]="log" placeholder="No Default"></template-selector>
            </label>
        </div>
        <div class="p-sm-6 p-col-12 flex justify-end items-center">
            <button pButton (click)="showNewTemplateDialog()" class="new-template-button p-button-success p-button-rounded" [icon]="Icons.PLUS" label="New Template"></button>
        </div>
    </div>
    <div class="p-grid p-fluid">
        <div class="p-col-12">
            <p-table [value]="(templates$ | async) ?? []" sortField="name" styleClass="p-datatable-striped">
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="999">
                      <div class="flex justify-center">
                        <label *ngIf="searchValue.value.length">
                          No templates match {{searchValue.value}}
                        </label>
                        <label *ngIf="!searchValue.value.length">
                          No templates
                        </label>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="name" [style.width]="'30%'">
                          <div class="flex flex-col gap-y-2">
                            <div>
                              Template
                              <p-sortIcon field="name"></p-sortIcon>
                            </div>
                            <input pInputText type="text" [(ngModel)]="searchValue.value" placeholder="Search" (click)="$event.stopPropagation()" />
                          </div>
                        </th>
                        <th pSortableColumn="templateType.name">Type <p-sortIcon field="templateType.name"></p-sortIcon> </th>
                        <th>
                            Usage
                            <p-columnFilter field="usageFilterOptions" display="menu" matchMode="usage-filter"
                                            [showMatchModes]="false" [showApplyButton]="false" [showClearButton]="false"
                                            [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <label class="p-d-block">
                                        Web
                                        <p-dropdown [(ngModel)]="usageFilter.enterNotes" [options]="usageFilterOptions" (onChange)="filter()"></p-dropdown>
                                    </label>
                                    <label class="p-d-block">
                                        Evident
                                        <p-dropdown [(ngModel)]="usageFilter.evident" [options]="usageFilterOptions" (onChange)="filter()"></p-dropdown>
                                    </label>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th>
                            Access
                            <p-columnFilter field="accessFilterOptions" display="menu" matchMode="access-filter"
                                            [showMatchModes]="false" [showApplyButton]="false" [showClearButton]="false"
                                            [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                  <div class="grid grid-flow-col gap-x-3">
                                    <label [for]="keyedId('unused-templates')">Hide unused templates</label>
                                    <p-inputSwitch [inputId]="keyedId('unused-templates')"
                                                   [(ngModel)]="accessFilter.filterUnused"
                                                   (ngModelChange)="filter(value)"></p-inputSwitch>
                                  </div>
                                  <lb-user-list-selector [logId]="log.id"
                                                         type="logUser"
                                                         [(ngModel)]="accessFilter.allowedUsers"
                                                         (ngModelChange)="filter(value)"></lb-user-list-selector>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th [style.width]="'10%'">Segments</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-template>
                    <tr>
                        <td>
                            <div class="flex flex-col gap-y-1">
                                <div>
                                  <button pButton *ngIf="!template.isDefaultTemplate" class="p-button-text p-0 w-auto p-text-left"
                                          [label]="template.name" (click)="editingTemplate = template">
                                  </button>
                                </div>
                                <p-tag *ngIf="isDefaultTemplate(template)" value="Default"></p-tag>
                                <div *ngIf="!template.isDefaultTemplate" class="p-text-secondary text-xs">
                                  <div>
                                    Updated {{template.updated | date: 'MM/dd/yyyy HH:mm'}}
                                  </div>
                                  <div>
                                    by {{template.updatedBy.firstName}} {{template.updatedBy.lastName}}
                                  </div>
                                </div>
                                <span *ngIf="template.isDefaultTemplate" class="p-m-0">
                                    {{template.name}}
                                </span>
                            </div>
                        </td>
                        <td>
                          <div class="flex flex-col">
                            <span>{{template.templateType.name}}</span>
                            <p-tag styleClass="subtemplate-tag" *ngIf="template.hasSubTemplates" value="Subtemplates"></p-tag>
                          </div>
                        </td>
                        <td>
                          <div class="usage-grid gap-y-2">
                            <div>
                              <span>Web:</span>
                            </div>
                            <div>
                              <lb-inplace-editor (onAccept)="saveUsageValue(template, 'enterNotes')"
                                                 (onReject)="getUsageValue(template, 'enterNotes').rollback()"
                                                 acceptLabel="Save">
                                <ng-container display>
                                  <button pButton class="p-button-link p-py-0 p-d-inline"
                                          [label]="template.enterNotes ? 'Yes' : 'No'"></button>
                                </ng-container>
                                <ng-container content>
                                  <div class="flex justify-center">
                                    <p-checkbox [binary]="true"
                                                [(ngModel)]="getUsageValue(template, 'enterNotes').value"></p-checkbox>
                                  </div>
                                </ng-container>
                              </lb-inplace-editor>
                            </div>
                            <div>
                              <span>Evident:</span>
                            </div>
                            <div>
                              <lb-inplace-editor (onAccept)="saveUsageValue(template, 'evident')"
                                                 (onReject)="getUsageValue(template, 'evident').rollback()"
                                                 acceptLabel="Save">
                                <ng-container display>
                                  <button pButton class="p-button-link p-py-0 p-d-inline"
                                          [label]="template.evident ? 'Yes' : 'No'"></button>
                                </ng-container>
                                <ng-container content>
                                  <div class="flex justify-center">
                                    <p-checkbox [binary]="true"
                                                [(ngModel)]="getUsageValue(template, 'evident').value"></p-checkbox>
                                  </div>
                                </ng-container>
                              </lb-inplace-editor>
                            </div>
                          </div>
                        </td>
                        <td>
	                        <lb-inplace-editor #accessEditor
	                                           (onAccept)="saveAccessValue(template)"
	                                           (onReject)="getAccessValue(template).discard()"
	                                           [clickable]="false"
	                                           acceptLabel="Save">
<!--                        Uses pTemplate instead of content projection to prevent logUsers being loaded when not needed-->
		                        <ng-template pTemplate="display">
			                        <div class="flex justify-left">
				                        <button pButton class="p-button-link p-0 w-auto" (click)="accessEditor.activate()">
					                        {{ template.allowAllUsers ? 'All' : (template.allowedUsers.length > 0) ? (template.allowedUsers.length + ' users') : 'None' }}
				                        </button>
			                        </div>
		                        </ng-template>
		                        <ng-template pTemplate="content">
			                        <lb-all-user-selector [(ngModel)]="getAccessValue(template).value"
			                                              [logId]="template.logId"></lb-all-user-selector>
		                        </ng-template>
	                        </lb-inplace-editor>
                        </td>
                        <td>
                            <span *ngIf="!template.isDefaultTemplate">
                                {{template.numSegments}}
                            </span>
                        </td>
                        <td class="p-text-right">
                            <button pButton *ngIf="!template.isDefaultTemplate" class="p-button-text p-button-secondary"
                                    (click)="templateOptionsMenu.show($event)"
                                    [disabled]="template.isDefaultTemplate"
                                    [icon]="Icons.ELLIPSIS_V">
                            </button>
                            <p-menu #templateOptionsMenu appendTo="body" [popup]="true" [model]="getTemplateOptionsMenu(template)"></p-menu>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</ng-container>

<div *ngIf="editingTemplate" class="p-grid">
    <div class="p-col-12">
        <button pButton label="Back" (click)="editingTemplate = undefined" iconPos="left" icon="pi pi-chevron-left"></button>
    </div>
    <div class="p-col-12">
        <lb-template-detail [template]="editingTemplate"></lb-template-detail>
    </div>
</div>

<ng-template #templateNewTemplatePicture let-templateType="templateType">
    <div class="template-example-picture-container p-d-flex p-flex-column">
        <ng-container [ngSwitch]="templateType">
            <ng-container *ngSwitchCase="TEMPLATE_TYPES.INSPECTION">
                <p class="p-text-center">
                    An inspection note is often, but not always, used for inspections, walk downs or rounds.<br>
                    Its fields are formatted into a table.
                </p>
                <img *ngIf="templateType" alt="Inspection Example Photo" src="assets/images/inspection_ex.png">
            </ng-container>
            <ng-container *ngSwitchCase="TEMPLATE_TYPES.OPERATIONAL">
                <p class="p-text-center">
                    An operational note is presented as a sentence or paragraph. They are used for recording events or actions taken as they occur.
                    <br><br>
                    Subtemplates can optionally be enabled to set up grouping for convenience when entering notes.
                </p>
                <img alt="Operational Example Photo" src="assets/images/operational_ex.png">
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<lb-template-copy (complete)="refreshTemplates()" [(visible)]="copyTemplateVisible" [template]="copyingTemplate ?? null"></lb-template-copy>

<template-segment-clipboard></template-segment-clipboard>
